import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array, fragment } from 'ember-data-model-fragments/attributes';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type PersonType from '@linc-technologies/linced-common/enums/person-type';
import type BulkImportSkippedEmail from 'linced-app/models/people/bulk-import-skipped-email';

// Proto: people.BulkImportLogEntry.
export default class BulkImportLogEntry extends Fragment {
  declare [Type]: 'people/bulk-import-log-entry';

  // row is the index of the import row this log entry relates to.
  @attr('number', { defaultValue: 0 })
  declare row: number;

  // personType is the type of Person imported.
  @attr('number', { defaultValue: 0 })
  declare personType: EnumValue<typeof PersonType> | 0;

  // personId is the unique identifier of the Person who was imported.
  @attr('string', { defaultValue: '' })
  declare personId: string;

  // name is the name of the person, if known.  Useful when skipped, or when
  // an error has occurred, as we may not have a personId in those cases.
  @attr('string', { defaultValue: '' })
  declare name: string;

  // outcome is the result of importing this Person.
  @attr('number', { defaultValue: 0 })
  declare outcome: number;

  // warnings is a list of warning messages relating to importing this Person.
  @array('string')
  declare warnings: StatefulArray<string>;

  // errors is a list of error messages relating to importing this Person.
  @array('string')
  // @ts-expect-error the proto errors field replaces the Fragment errors.
  declare errors: StatefulArray<string>;

  // skippedEmail contains metadata relating to an email address which was
  // skipped due to an unresolvable conflict.
  @fragment('people/bulk-import-skipped-email')
  declare skippedEmail: BulkImportSkippedEmail | null;
}
